export default __webpack_public_path__ + "bd5b7a13f2c52b531a2a787bf6eb4a13.woff";